import React, { useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import './CheckoutForm.css';

// Load Stripe with your public key
const stripePromise = loadStripe('pk_live_51QAauPFDMH9yMARuDmFwg2CT77wHGO0Fq5DVgXrqWngnVG23v28KUpJwEgS9RmfMiHigI6IFsurQ2nI3uO5x4PBl00Js2CFeLg'); 

//const stripePromise = loadStripe('pk_test_51QAauPFDMH9yMARuBQqFYoZLBHIV5iHMpJ0k6FkG4ttYNVBF66HRMIxiqWIA5udHjUR86oaBD85SLTajipkPJv2Q00Ps7rI962'); 

const CheckoutForm = () => {
  const [selectedOption, setSelectedOption] = useState('');

  // Predefined bundles with Stripe Checkout URLs
  const bundles = [
    {
      name: '5 Token Bundle',
      price: '$3.50',
      tokenCount: 5,
    //  checkoutUrl: 'https://buy.stripe.com/test_14k9BG7EE2Krak08ww',
      checkoutUrl: 'https://buy.stripe.com/eVa3frdv84H6fyU3cd',
    },
    {
      name: '10 Token Bundle',
      price: '$6.50',
      tokenCount: 10,
      checkoutUrl: 'https://buy.stripe.com/cN2aHT4YCddC72o4gi',
    },
    {
      name: '30 Token Bundle',
      price: '$18',
      tokenCount: 30,
      checkoutUrl: 'https://buy.stripe.com/4gwg2d3Uyb5uaeAdQT',
    },
    {
      name: '50 Token Bundle',
      price: '$27.50',
      tokenCount: 50,
      checkoutUrl: 'https://buy.stripe.com/5kA3fr3Uy4H69aw5ko',
    },
    {
      name: '100 Token Bundle',
      price: '$50',
      tokenCount: 100,
      checkoutUrl: 'https://buy.stripe.com/4gwg2d76KflK1I45kp',
    },
    {
      name: '1 Month Unlimited Subscription',
      price: '$20',
      tokenCount: 'Unlimited',
      checkoutUrl: 'https://buy.stripe.com/6oE2bn76KehGfyU9AG',
    },
    {
      name: '3 Month Unlimited Subscription',
      price: '$50',
      tokenCount: 'Unlimited',
      checkoutUrl: 'https://buy.stripe.com/aEUbLX2Quc9y9awbII',
    },
  ];

  const handleCheckout = async () => {
    if (!selectedOption) {
      alert('Please select a bundle.');
      return;
    }

    const stripe = await stripePromise;

    const selectedBundle = bundles.find((bundle) => bundle.name === selectedOption);

    if (stripe && selectedBundle) {
      // Redirect to Stripe Checkout URL
      window.open(selectedBundle.checkoutUrl, '_blank');
    }
  };

  return (
    <div className="checkout-form">
      <h2>Purchase Tokens or Subscriptions</h2>
      <p className="checkout-note">
        <strong>Note:</strong> 1 token = 1 essay analysis which can be used on any type of essay. 
        When you press the analyze button, 1 token will be subtracted from your account balance. 
        All subscription plans grant unlimited tokens.
      </p>
      <div className="bundle-options">
        {bundles.map((bundle, index) => (
          <label key={index} className="bundle-option">
            <input
              type="radio"
              name="bundle"
              value={bundle.name}
              onChange={(e) => setSelectedOption(e.target.value)}
            />
            {bundle.name} - {bundle.price} ({bundle.tokenCount} tokens)
          </label>
        ))}
      </div>
      <button onClick={handleCheckout} className="submit-button-payment">
        Proceed to Payment
      </button>
    </div>
  );
};

export default CheckoutForm;

